import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/views/layout/layout';
import layout_empty from '@/views/layout/layout_empty';

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '',
      component: layout,
      redirect: 'index',
      children: [{
        path: 'index',
        component: () => import('@/views/question/index')
      }]
    },
    {
      path: '/question',
      component: layout,
      children: [{
        path: 'detail',
        component: () => import('@/views/question/detail')
      }]
    },
    {
      path: '/question',
      component: layout,
      children: [{
        path: 'add',
        component: () => import('@/views/question/add')
      }]
    },
    {
      path: '/question',
      component: layout,
      children: [{
        path: 'edit',
        component: () => import('@/views/question/edit')
      }]
    },    
    {
      path: '/user',
      component: layout,
      children: [{
        path: 'detail',
        component: () => import('@/views/user/detail')
      }]
    },
    {
      path: '/weichatsuccess',
      component: layout,
      children: [{
        path: '',
        component: () => import('@/views/weichatsuccess')
      }]
    },
    {
      path: '/aichat',
      component: layout,
      children: [{
        path: '',
        component: () => import('@/views/aichat/chat')
      }]
    },   
    {
      path: '/aichat2',
      component: layout_empty,
      children: [{
        path: '',
        component: () => import('@/views/aichat/chat2')
      }]
    },     
    {
      path: '/docfeedback',
      component: layout,
      children: [{
        path: '',
        component: () => import('@/views/doccenter/feedback')
      }]
    },      
    {
      path: '/latestdocs',
      component: layout,
      children: [{
        path: '',
        component: () => import('@/views/doccenter/latestdocs')
      }]
    },     
    {
      path: '/lczreleaselog',
      component: layout,
      children: [{
        path: '',
        component: () => import('@/views/message/lczReleaseLog')
      }]
    },    
    {
      path: '/msgpage',
      component: layout,
      children: [{
        path: '',
        component: () => import('@/views/message/msgpage')
      }]
    },      
    {
      path: '/wf',
      component: layout_empty,
      children: [{
        path: '',
        component: () => import('@/views/aichat/wfdesign')
      }]
    },      
    {
      path: '/login',
      component: layout,
      children: [{
        path: '',
        component: () => import('@/views/login')
      }]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js